import { USER_ROLE_LABELS } from '@almacen/shared';
import { Avatar, Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconKey, IconLogout } from '@tabler/icons-react';
import { useState } from 'react';
import { useAuth } from '../../auth/auth-context';
import { ChangePasswordModal } from './ChangePasswordModal';

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
}

export function UserMenu() {
  const { user, logout } = useAuth();
  const [passwordOpen, setPasswordOpen] = useState(false);
  if (!user) return null;

  return (
    <>
      <Menu position="bottom-end" width={220}>
        <Menu.Target>
          <UnstyledButton aria-label="Menú de usuario">
            <Group gap="xs" wrap="nowrap">
              <Avatar color="blue" radius="xl" size="md">
                {initials(user.fullName)}
              </Avatar>
              <div style={{ lineHeight: 1.1 }} className="hide-on-mobile">
                <Text size="sm" fw={600}>
                  {user.fullName}
                </Text>
                <Text size="xs" c="dimmed">
                  {USER_ROLE_LABELS[user.role]}
                </Text>
              </div>
            </Group>
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>{user.username}</Menu.Label>
          <Menu.Item leftSection={<IconKey size={16} />} onClick={() => setPasswordOpen(true)}>
            Cambiar contraseña
          </Menu.Item>
          <Menu.Item
            color="red"
            leftSection={<IconLogout size={16} />}
            onClick={() => void logout()}
          >
            Cerrar sesión
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
      <ChangePasswordModal opened={passwordOpen} onClose={() => setPasswordOpen(false)} />
    </>
  );
}
